/* ============================================================
   Brand Page — comportamenti condivisi
   1) Reveal progressivo + parallax hero (richiede GSAP)
   2) Scroll orizzontale della striscia foto: rotellina + drag
      (indipendente da GSAP, funziona sempre)
   Degrada con grazia: se GSAP non c'è o reduced-motion,
   le animazioni si spengono ma lo scroll della gallery resta.
   ============================================================ */
(function () {
  'use strict';

  // --- Reveal + parallax (richiede GSAP) ---
  function initAnim(root) {
    if (root.dataset.bpAnim === '1') return;
    root.dataset.bpAnim = '1';

    var reduce =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasGSAP = typeof window.gsap !== 'undefined';

    if (reduce || !hasGSAP) {
      root.classList.add('no-anim');
      return;
    }

    var gsap = window.gsap;
    if (window.ScrollTrigger) {
      gsap.registerPlugin(window.ScrollTrigger);
    }

    root.classList.add('is-ready');

    // Reveal a gruppi: ogni [data-reveal] sale e sfuma all'ingresso
    var items = root.querySelectorAll('[data-reveal]');
    items.forEach(function (el) {
      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 1.05,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 86%',
          once: true,
        },
      });
    });

    // Parallax leggero sull'immagine hero
    var heroMedia = root.querySelector('.bp__hero-media');
    var hero = root.querySelector('.bp__hero');
    if (heroMedia && hero && window.ScrollTrigger) {
      gsap.to(heroMedia, {
        yPercent: 12,
        ease: 'none',
        scrollTrigger: {
          trigger: hero,
          start: 'top top',
          end: 'bottom top',
          scrub: true,
        },
      });
    }
  }

  // --- Scroll orizzontale della striscia foto (rotellina + drag) ---
  function initGallery(track) {
    if (track.dataset.bpScroll === '1') return;
    track.dataset.bpScroll = '1';

    // Rotellina verticale del mouse → scroll orizzontale.
    // Solo finché c'è spazio: ai bordi lascia scorrere la pagina.
    var wheelTimer = null;
    track.addEventListener(
      'wheel',
      function (e) {
        // Gesto orizzontale del trackpad: lo gestisce già il browser
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        var atStart = track.scrollLeft <= 0;
        var atEnd =
          track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        if ((e.deltaY < 0 && atStart) || (e.deltaY > 0 && atEnd)) return;
        e.preventDefault();
        // Disattiva lo snap mentre la rotellina è in uso: senza questo lo
        // scroll-snap riporta indietro ogni nudge e la striscia non scorre.
        // A scorrimento fermo (dopo il debounce) lo snap torna attivo e
        // rifinisce dolcemente la posizione.
        track.classList.add('is-wheeling');
        track.scrollLeft += e.deltaY;
        if (wheelTimer) clearTimeout(wheelTimer);
        wheelTimer = setTimeout(function () {
          track.classList.remove('is-wheeling');
        }, 220);
      },
      { passive: false }
    );

    // Trascinamento col mouse → scroll orizzontale, senza attivare i link
    var down = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // touch: scroll nativo
      down = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
    });

    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      // Attiva il drag (cursore + pointer capture) SOLO oltre la soglia: così
      // un semplice click NON cattura il pointer e il link naviga normalmente.
      // (setPointerCapture su pointerdown sopprimeva il click su desktop.)
      if (!moved && Math.abs(dx) > 4) {
        moved = true;
        track.classList.add('is-dragging');
        try {
          track.setPointerCapture(e.pointerId);
        } catch (err) {}
      }
      if (moved) track.scrollLeft = startScroll - dx;
    });

    function endDrag(e) {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      try {
        track.releasePointerCapture(e.pointerId);
      } catch (err) {}
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    // Se l'utente ha trascinato, annulla il click sul link (no navigazione)
    track.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );

    // Evita il "drag fantasma" dell'immagine del browser
    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
  }

  // --- Scroll morbido verso un'ancora in pagina (link con [data-bp-scroll]) ---
  function initScrollLinks(scope) {
    var links = scope.querySelectorAll('a[data-bp-scroll]');
    links.forEach(function (a) {
      if (a.dataset.bpScrollInit === '1') return;
      a.dataset.bpScrollInit = '1';
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;
        var tgt = document.querySelector(href);
        if (!tgt) return;
        e.preventDefault();
        // Se il link è una card settore, pre-seleziona quel settore nel form
        var sector = a.getAttribute('data-sector');
        if (sector) {
          var sel = document.getElementById('rp-settore');
          if (sel) {
            for (var i = 0; i < sel.options.length; i++) {
              if (sel.options[i].value === sector) {
                sel.selectedIndex = i;
                break;
              }
            }
          }
        }
        // Variante generica: pre-seleziona un <select> qualsiasi in pagina
        // (es. card capo del Noleggio → select "Capo" del form preventivo)
        var selId = a.getAttribute('data-bp-select');
        var selVal = a.getAttribute('data-bp-value');
        if (selId && selVal) {
          var sel2 = document.getElementById(selId);
          if (sel2) {
            for (var j = 0; j < sel2.options.length; j++) {
              if (sel2.options[j].value === selVal) {
                sel2.selectedIndex = j;
                break;
              }
            }
          }
        }
        // Compensa l'header sticky per non nascondere il titolo di sezione
        var header = document.getElementById('header-component');
        var offset = header ? header.getBoundingClientRect().height : 0;
        var y = window.scrollY + tgt.getBoundingClientRect().top - offset - 16;
        var reduce =
          window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        // scrollTo JS (non la CSS scroll-behavior, che altrove rompe ScrollTrigger)
        window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-bp-root]').forEach(initAnim);
    document.querySelectorAll('.bp-gallery__track').forEach(initGallery);
    initScrollLinks(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init nel theme editor di Shopify quando una sezione viene ricaricata
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-bp-root]');
    if (root) initAnim(root);
    e.target.querySelectorAll('.bp-gallery__track').forEach(initGallery);
    initScrollLinks(e.target);
  });
})();
